import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AreYouSure from "../modal/AreYouSure";
import { adminLogout, clientLogout } from "../store/authSlice";
import { closeModal, selectModal, selectModalProps } from "../store/uiSlice";
import { logoutAdmin } from "../services/portalApi";

export default function ModalHost() {
  const modal = useSelector(selectModal);
  const modalProps = useSelector(selectModalProps);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    dispatch(adminLogout());
    dispatch(clientLogout());
    dispatch(closeModal());

    window.location.assign("/");

    logoutAdmin().catch(() => null);
    setLoading(false);
  };

  if (modal !== "confirmLogout") return null;

  return (
    <AreYouSure
      open
      title={modalProps.title || "Logout?"}
      message={modalProps.message || "Do you want to logout?"}
      confirmText="Logout"
      loading={loading}
      onClose={() => dispatch(closeModal())}
      onConfirm={handleLogout}
    />
  );
}
